@if (contentVariant) {
<modal-layout-middle (close)="close()"
                     [sideImage]="contentVariant.image">
    <!-- title -->
    <p class="h3 m-t-7 m-t-10-s"
       *iCms="'title' of contentVariant"
       text></p>
    <!-- subtitle 1 -->
    <p class="s2 m-t-7 m-t-9-s"
       *iCms="'subtitle1' of contentVariant; content: 'html'"></p>
    <!-- subtitle 2 -->
    <p class="s2 m-t-7 m-t-6-s"
       *iCms="'subtitle2' of contentVariant; content: 'html'"></p>
    <!-- go to default -->
    <button class="w-12 m-t-6 m-t-9-s button"
            (click)="confirm()">
        <span class="button__body"
              *iCms="'confirmButtonCopy' of contentVariant"
              text></span>
    </button>
    <!-- stay on website -->
    @if (!contentVariant.hideStayOnWebsiteButton) {
    <button class="w-12 m-t-3 button-1"
            (click)="stay()">
        <span class="button__body"
              *iCms="'closeButtonCopy' of contentVariant"
              text></span>
    </button>
    }
    <!-- view all -->
    <button class="m-t m-b-7 m-t-3-s m-b-3-s button-inline"
            (click)="viewAll()">
        <span *iCms="'viewAllCopy' of contentVariant"
              text></span>
    </button>
</modal-layout-middle>
}